import React, { Component } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Button } from "shards-react";
import Firebase from 'firebase';
import { Link } from 'react-router-dom';
import { StaticRouter } from 'react-router';
import { set } from 'react-ga';
import { Satellite } from '@material-ui/icons';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


class SignUpFormKidsComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lastname:'',
            firstname:'',
            adres:'',
            postal:'',
            city:'',
            mail:'',
            phone:'',
            birthday:'',
            school:'',
            group:'',
            emergencyName:'',
            emergencyPhone:'',
            nameDoctor:'',
            numberInsurance:'',
            phoneDoctor:'',
            specialties:'',
            choiceNameOne:'',
            choiceNameTwo:'',
            choiceSchoolOne:'',
            choiceSchoolTwo:'',
            aloneToHome:'selected',
            typeAge:'selected',
            pickedUpBy:'',
            swimCertificate:'selected',
            terms:false,
            orderid:'',
            orders:[]
        };

    }




    componentDidMount() {

        let ref = Firebase.database().ref('/orders/');
        ref.on('value' , snapshot => {

            snapshot.forEach((childSnap) => {
                let state = childSnap.val();
   
              
                    this.setState(prevState => ({
                        orders: [...prevState.orders, state]
                    }))  })
           

           
             this.setState({
                 orderid: 'KVW00'+(this.state.orders.length+1)
             })
            
        });
   
        
    }
    handleaVariations(event){
        console.log(event)
        
                if(this.state.terms === true){
                    this.setState({
                        terms: false
                    })
                }else if(this.state.terms === false){
                    this.setState({
                        terms: true
                    })
                }
                
            }

    

    

    render() {
        return (
            <div>
            <Row className="col-sm-12">
            <Col sm={12} className="form-overview">
            <form method="post" action={"https://us-central1-kvw-beek.cloudfunctions.net/payment"} id="hook-form" >
               <h3>Persoonsgegevens</h3>
              
                <label>Achternaam</label><br/>
                <input type="text" name="lastname"  value={this.state.lastname} onChange={(event)=>this.setState({lastname:event.target.value})}/><br/><br/>
                <label>Voornaam</label><br/>
                <input type="text" name="firstname"  value={this.state.firstname} onChange={(event)=>this.setState({firstname:event.target.value})}/><br/><br/>
                <label>Adres + huisnummer</label><br/>
                <input type="text" name="adres"   value={this.state.adres} onChange={(event)=>this.setState({adres:event.target.value})}/><br/><br/>
                <label>Postcode</label><br/>
                <input type="text" name="postal"   value={this.state.postal} onChange={(event)=>this.setState({postal:event.target.value})}/><br/><br/>
                <label>Woonplaats</label><br/>
                <input type="text" name="city"   value={this.state.city} onChange={(event)=>this.setState({city:event.target.value})}/><br/><br/>
                <label>E-mail</label><br/>
                <input type="text" name="mail"   value={this.state.mail} onChange={(event)=>this.setState({mail:event.target.value})}/><br/><br/>
                <label>Telefoonnummer</label><br/>
                <input type="text" name="phone"   value={this.state.phone} onChange={(event)=>this.setState({phone:event.target.value})}/><br/><br/>
                <label>Geboortdatum</label><br/>
                <input type="text" name="birthday"   value={this.state.birthday} onChange={(event)=>this.setState({birthday:event.target.value})}/><br/><br/>
                <h3>Schoolgegevens (vul hier je gegevens in van schooljaar 2020-2021)</h3>
                <label>School</label><br/>
                <input type="text" name="school"   value={this.state.school} onChange={(event)=>this.setState({school:event.target.value})}/><br/><br/>
                <label>Groep</label><br/>
                <input type="text" name="group"   value={this.state.group} onChange={(event)=>this.setState({group:event.target.value})}/><br/><br/>
                <label>Junioren / Senioren:</label><br/>
                <select name="typeAge"   value={this.state.typeAge} onChange={(event)=>this.setState({typeAge: event.target.value})}>
                            <option selected="selected" disabled="disabled">Selecteer een optie</option>
                                <option value="2,3,4,5 (Junioren)">2,3,4,5 (Junioren)</option>
                                <option value="6,7,8 (Senioren)">6,7,8 (Senioren)</option>
                            </select><br/><br/>
                <label>Zwemdiploma:</label><br/>
                <select name="swimCertificate" onChange={(event)=>this.setState({swimCertificate: event.target.value})}>
                            <option selected="selected" disabled="disabled">Selecteer een optie</option>
                                <option value="Ja">Ja</option>
                                <option value="Nee">Nee</option>
                            </select><br/><br/>
                <h3>Als mijn ouders niet thuis zijn en in geval van nood kan er contact worden opgenomen met</h3>
                <label>Naam</label><br/>
                <input type="text" name="emergencyName"  value={this.state.emergencyName} onChange={(event)=>this.setState({emergencyName:event.target.value})}/><br/><br/>
                <label>Telefoon</label><br/>
                <input type="text" name="emergencyPhone"  value={this.state.emergencyPhone} onChange={(event)=>this.setState({emergencyPhone:event.target.value})}/><br/><br/>
                <h3>Gegevens zorgverzekeraar / huisarts</h3>
                <label>Naam ziektekostenverzekering</label><br/>
                <input type="text"  name="nameDoctor" value={this.state.nameDoctor} onChange={(event)=>this.setState({nameDoctor:event.target.value})}/><br/><br/>
                <label>Verzekeringsnummer</label><br/>
                <input type="text" name="numberInsurance"  value={this.state.numberInsurance} onChange={(event)=>this.setState({numberInsurance:event.target.value})}/><br/><br/>
                <label>Huisarts + telefoonnummer</label><br/>
                <input type="text" name="phoneDoctor"  value={this.state.phoneDoctor} onChange={(event)=>this.setState({phoneDoctor:event.target.value})}/><br/><br/>
                <h3>Overige bijzonderheden/ medische gegevens</h3>
                <label>Overige bijzonderheden / medische gegevens</label><br/>
                <span>(schrijf hier op als je medicatie gebruikt, een bepaalde ziekte of beperking hebt, allergieën hebt, we rekening met je geloof dienen te houden, je wagenziek bent, er bijzondere omstandigheden zijn waar we rekening mee moeten / kunnen houden, etc.)</span><br/><br/>
                <textarea value={this.state.specialties} name="specialties" onChange={(event)=>this.setState({specialties: event.target.value})} />
                <h3>Ik wil graag in de groep bij</h3>
                <label>1. Naam:</label><br/>
                <input type="text"  name="choiceNameOne"  value={this.state.choiceNameOne} onChange={(event)=>this.setState({choiceNameOne:event.target.value})}/><br/><br/>
                <label>School</label><br/>
                <input type="text" name="choiceSchoolOne"  value={this.state.choiceSchoolOne} onChange={(event)=>this.setState({choiceSchoolOne:event.target.value})}/><br/><br/>
                <label>2. Naam:</label><br/>
                <input type="text" name="choiceNameTwo"   value={this.state.choiceNameTwo} onChange={(event)=>this.setState({choiceNameTwo:event.target.value})}/><br/><br/>
                <label>School</label><br/>
                <input type="text" name="choiceSchoolTwo"   value={this.state.choiceSchoolTwo} onChange={(event)=>this.setState({choiceSchoolTwo:event.target.value})}/><br/><br/>
                <h3>Brengen / halen</h3>
                <label>Ik mag wel/ niet alleen naar huis als KVW is afgelopen</label><br/>
                <select value={this.state.aloneToHome} name="aloneToHome"  onChange={(event)=>this.setState({aloneToHome: event.target.value})}>
                            <option selected="selected" disabled="disabled">Selecteer een optied</option>
                                <option value="Wel">Wel</option>
                                <option value="Niet">Niet</option>
                            </select><br/><br/>
                            <label>Ik word opgehaald door: (let bij ophalen erop dat u onder aan de berg parkeert)</label><br/>
                <input type="text"  value={this.state.pickedUpBy} name="pickedUpBy" onChange={(event)=>this.setState({pickedUpBy:event.target.value})}/><br/><br/>
                <h3>Voorwaarden</h3>
                <span>Met het verzenden van dit formulier ga ik akkoord met de regel dat de organisatie zich niet aansprakelijk stelt voor persoonlijke schade, verlies, diefstal en/of beschadiging van persoonlijke eigendommen van of aan derden, ontstaan voor, na of tijdens een activiteit.<br/>
Tevens geef ik bij het verzenden van dit formulier toestemming aan KinderVakantieWerk Beek om de ingevulde persoonsgegevens te verwerken.<br/>
De opgegeven persoonsgegevens zullen uitsluitend gebruikt worden door KinderVakantieWerk Beek en niet aan derden worden verstrekt.<br/>
De organisatie dient zich te houden aan de landelijke Covid-19 richtlijnen. Je deelname is dus onder voorbehoud en
kan te allen tijde gewijzigd worden. Hiervoor kan de organisatie niet aansprakelijk gesteld worden.<br/>
<br/>
*Indien u deze toestemming in wil trekken, kunt u contact opnemen met de organisatie.
Foto’s die tijdens de week gemaakt worden, worden enkel gebruikt voor onze eigen promotiedoeleinden.
</span><br/><br/>
<input type="checkbox" name="terms" checked={this.state.terms} onChange={(event)=> this.handleaVariations(event.target.value)} required/><label>Ik ga akkoord</label>
<br/><br/>
<button type="submit" className="subtmit-button" form="hook-form">Inschrijving afronden</button>
<input type="text" name="orderId" hidden value={this.state.orderid} /><br/><br/>

            </form>
            </Col>
      
   
            </Row>
            </div>



        );
    }
};

export default SignUpFormKidsComponent;